// extracted by mini-css-extract-plugin
export default {"Foundation":"ExporeTechRoles_Foundation__jr5on","Container1":"ExporeTechRoles_Container1__OMRad","Container2":"ExporeTechRoles_Container2__iW4eK"};